function getInfo (info) {
  let location = window.location.hostname
  let project = 'awp'
  if (location == 'rpw.quantis.it') {
    location = 'rpw.quantis.it/new'
    project = 'new'
  }
  if (location == 'pfa.quantis.it') {
    location = 'pfa.quantis.it'
    project = 'pfa'
  }
  if (location == 'localhost:4000') {
    const pfa = window.location.pathname.split('/').filter(x => x == 'pfa')
    const newS = window.location.pathname.split('/').filter(x => x == 'new')
    const awp = window.location.pathname.split('/').filter(x => x == 'awp')
    location = 'localhost:4000'
    project = 'awp'
    if (pfa.length > 0) {
      location = 'localhost:4000/pfa'
      project = 'pfa'
    }
    if (awp.length > 0) {
      location = 'localhost:4000'
      project = 'awp'
    }
    if (newS.length > 0) {
      location = 'localhost:4000/new'
      project = 'new'
    }
  }
  if (info == 'location') {
    return location
  } else {
    return project
  }
}
export const ProjectInfo = {
  projectName: (getInfo('name') + '-UI').toUpperCase(),
  customerName: '',
  projectLogo: getInfo('name') + '.png',
  progectLogoMinimized: getInfo('name') + '.png',
  customerLogo: 'customerlogo.png',
  backendAPI: {
    username: 'Quantis',
    password: 'WorkflowAPI',
    basePath: '/api',
    basePathRaker: '/rakerapi',
    basePathRaiden: 'awp.quantis.it'
  }
}
export const environment = {
  production: true,
  API_URL: window.location.protocol !== 'https:' ? 'http://' + getInfo('location') + ProjectInfo.backendAPI.basePath : 'https://' + getInfo('location') + ProjectInfo.backendAPI.basePath,
  API_URL_RAKER: window.location.protocol !== 'https:' ? 'http://' + getInfo('location') + ProjectInfo.backendAPI.basePathRaker : 'https://' + getInfo('location') + ProjectInfo.backendAPI.basePathRaker,
  API_URL_RAIDEN: window.location.protocol !== 'https:' ? 'http://' + ProjectInfo.backendAPI.basePathRaiden : 'https://' + ProjectInfo.backendAPI.basePathRaiden,
  PM2_MONITOR_URL: window.location.protocol !== 'https:' ? 'http://' + getInfo('location') : 'https://' + getInfo('location'),
  PM2_MONITOR_PATH: '/pm2-monitor/socket.io',
  CLIENT_ID: '2461063c-4dd3-450c-a1b3-02147549e984',
  CLOUD_INSTANCE: 'https://login.microsoftonline.com/',
  TENANT_ID: '761de76f-3d5c-4174-917c-5ad4d06360cb',
  REDIRECT_URI: 'https://awp.posteitaliane.it/mfa_login',
  GRAPH_API_ENDPOINT: 'https://graph.microsoft.com/',
  RTU_API_KEY: 'c8bda1e683130c4bbf0d8e496dd9f084392f34cac2d1222b4d93cc7f7ccf322a'
}

